var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"slot_top_img"},[_vm._t("top",[_c('img',{attrs:{"src":require("@/assets/image/标题1.png"),"alt":""}})])],2),_c('div',{staticClass:"contentWamp"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }